// Renders a lateral pitch value together with its polarity sign.
//
// Lateral pitch option lists include "opposite direction" entries at the bottom
// (e.g. "R 1/16" on the left finger / "L 1/16" on the right finger), stored as a
// negative decimal or with an R/L direction prefix. When polarity display is on,
// those opposite picks must show the OPPOSITE sign from the finger's normal
// direction (Azure #820) — otherwise a right-going pitch on a left finger prints
// as "+" when it should read "-".
//
// baseSign is the polarity sign for the finger's normal direction ("", "+", "-").
// When it is "" (polarity display off) the stored value is returned verbatim, so
// the R/L direction letter / negative decimal is preserved exactly as before.

const flipSign = (sign) => (sign === "+" ? "-" : sign === "-" ? "+" : "");

export const renderPitchWithPolarity = (baseSign, value) => {
  const raw = value === undefined || value === null ? "" : String(value);

  // Polarity display off: show the stored value as-is (keeps the R/L letter or
  // negative decimal that already conveys direction).
  if (baseSign === "") return raw;

  const trimmed = raw.trim();
  if (trimmed === "" || trimmed === "0" || trimmed === "0.000") return raw;

  // Opposite-direction picks are stored as a negative decimal ("-0.063") or with
  // an R/L direction prefix ("R 1/16" / "L 1/16").
  const isOpposite = trimmed.startsWith("-") || /^[RL]/i.test(trimmed);
  const sign = isOpposite ? flipSign(baseSign) : baseSign;

  // The sign now conveys direction, so strip the value's own direction indicator.
  const clean = trimmed.replace(/^-/, "").replace(/^[RL]\s*/i, "");
  return `${sign}${clean}`;
};
